<div
  class="suggest-container"
  style="padding: 20px; font-family: &quot;Roboto&quot;, sans-serif"
>
  <h3 style="margin-top: 0; color: #0078d4">💡 Folie vorschlagen</h3>

  <p style="font-size: 14px; color: #555">
    Wir haben die aktuelle Folie aus deiner Präsentation extrahiert. Möchtest du
    uns noch eine kurze Notiz dazu hinterlassen?
  </p>

  <div
    *ngIf="!slideBase64"
    style="text-align: center; padding: 20px; color: #666"
  >
    <clr-spinner clrInline></clr-spinner> Lade Folie aus PowerPoint...
  </div>

  <div *ngIf="slideBase64 && !successMessage">
    <form (ngSubmit)="submitSuggestion()" clrForm clrLayout="vertical">
      <clr-textarea-container>
        <label>Dein Kommentar (Optional)</label>
        <textarea
          clrTextarea
          [(ngModel)]="comment"
          name="comment"
          rows="3"
          style="width: 100%"
          placeholder="Warum ist diese Folie besonders wertvoll?"
        ></textarea>
      </clr-textarea-container>

      <div
        *ngIf="errorMessage"
        style="color: red; margin-top: 10px; font-size: 13px"
      >
        {{ errorMessage }}
      </div>

      <div
        style="margin-top: 20px; display: flex; justify-content: space-between"
      >
        <button
          type="button"
          class="btn btn-outline"
          (click)="cancel()"
          [disabled]="isUploading"
        >
          Abbrechen
        </button>
        <button type="submit" class="btn btn-primary" [disabled]="isUploading">
          <span *ngIf="!isUploading">Jetzt einreichen</span>
          <span *ngIf="isUploading"
            ><clr-spinner clrInline clrSmall></clr-spinner> Lädt hoch...</span
          >
        </button>
      </div>
    </form>
  </div>

  <div
    *ngIf="successMessage"
    style="text-align: center; padding: 20px; color: green; font-weight: bold"
  >
    ✅ {{ successMessage }}
  </div>
</div>
